import { publishRun, getRun } from '../bailey/baileyRun';

/**
 * A call Bailey is on, shown wherever Bailey is: the desk pet and the tab's
 * Bailey pick up the handset, with one quiet line beside them.
 *
 * It rides the same run channel a reply uses (baileyRun.js), so every tab
 * hears it. The server doesn't say when a call starts yet
 * (docs/FRONT_DESK_BACKEND.md); until it does, Settings › Diary demo can play
 * a pretend one so the moment can be shown.
 */
export const CALL_TOOL = 'front_desk_call';
export const CALL_LINE = 'On the phone with a client';

const clock = (ms) => {
    const s = Math.max(0, Math.floor(ms / 1000));
    return `${Math.floor(s / 60)}:${String(s % 60).padStart(2, '0')}`;
};

export const isCall = (run) => !!(run && run.phase === 'working' && run.tool === CALL_TOOL);

let timer = null;

/** Start showing a call. Returns a function that ends it with an outcome line. */
export function startCall({ startedAt = Date.now() } = {}) {
    stopTicking();
    const tick = () => publishRun({
        phase: 'working', title: CALL_LINE, activity: CALL_LINE, tool: CALL_TOOL,
        preview: `${CALL_LINE} · ${clock(Date.now() - startedAt)}`, sessionId: null, source: 'frontdesk', callStartedAt: startedAt
    });
    tick();
    timer = setInterval(tick, 1000);
    return (outcome) => endCall(outcome);
}

export function endCall(outcome) {
    stopTicking();
    if (!isCall(getRun())) return;
    publishRun({ phase: 'done', activity: null, tool: null, preview: outcome || 'Call finished.', source: 'frontdesk' });
}

function stopTicking() {
    if (timer) { clearInterval(timer); timer = null; }
}

/** Staging only: a pretend call, for showing the pose. Nothing is dialled. */
export function demoCall(seconds = 40) {
    const end = startCall();
    const done = setTimeout(() => end('Call finished. I took a message for you.'), Math.max(3, seconds) * 1000);
    return () => { clearTimeout(done); end('Call finished.'); };
}
